module.exports = __webpack_public_path__ + "img/qr.8803296a.svg";